import { Button, Dropdown, Modal } from "antd";
import { useState } from "react";
import "./CreateFolderModal.scss";
import "./ChangeLocationModal.scss";
import { useRecoilState } from "recoil";
import { locationsState } from "../../state/atoms";
import { DownOutlined } from "@ant-design/icons";
import { LocationDto } from "../../generated/dashboard-client";
import LinkPagesApi from "../../api/LinkPagesApi";
import { useParams } from "react-router-dom";

export interface ChangePageLocationModalProps {
  isVisible: boolean;
  id: string;
  onClose: (id: string, saved: boolean) => void;
}

export function ChangePageLocationModal({
  isVisible,
  id,
  onClose,
}: ChangePageLocationModalProps) {
  const { locationId } = useParams();
  const [locations] = useRecoilState(locationsState);
  const [removing, setRemoving] = useState(false);
  const [moveToLocationId, setMoveToLocationId] = useState(0);
  const [locationName, setLocationName] = useState("");

  function assign() {
    setRemoving(true);
    LinkPagesApi.moveToLocation(id, moveToLocationId)
      .then(() => {
        setRemoving(false);
        if (moveToLocationId.toString() === locationId) {
          onClose(id, false);
        } else {
          onClose(id, true);
        }
      })
      .catch(() => {
        setRemoving(false);
      });
  }

  function setLocation(loc: LocationDto) {
    setMoveToLocationId(loc.internalId!);
    setLocationName(loc.name!);
  }

  const menu = (
    <div className={"loc-drop-menu change-loc-modal"}>
      <ul>
        {locations.map((it) => (
          <li key={it.id} onClick={() => setLocation(it)}>
            <div className={"lk"}>
              <h6>{it.name}</h6>
              <p>
                {it.address} {it.city}
                {it.state !== "" && <span>, {it.state}</span>}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <Modal
      className={"clean one"}
      visible={isVisible}
      onCancel={() => onClose(id, false)}
    >
      <header>
        <h2>Move link page to a new location</h2>
      </header>

      <Dropdown
        className={"loc-drop change-loc-modal"}
        overlay={menu}
        getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
        trigger={["click"]}
      >
        <Button
          type={"link"}
          size={"large"}
          onClick={(e) => e.preventDefault()}
        >
          {locationName !== "" && <span>{locationName}</span>}
          {locationName === "" && <span>Change Location</span>}
          <DownOutlined className={"carr"} />
        </Button>
      </Dropdown>

      <footer>
        <Button size={"large"} onClick={() => onClose(id, false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={assign}
          loading={removing}
        >
          Move
        </Button>
      </footer>
    </Modal>
  );
}
